import { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { AbandonedCheckoutListParams } from '../api/abandoned-checkouts-api';
import {
  ABANDONED_CHECKOUT_FILTER_FIELDS,
  ABANDONED_CHECKOUT_SORTS,
} from '../components/abandoned-checkout-filters';

/**
 * URL search params of the abandoned checkouts list; mirrors GET /admin/v1/stores/{storeId}/checkouts,
 * which has no text search.
 */
export const abandonedCheckoutListSearchSchema = indexSearchSchema(
  ABANDONED_CHECKOUT_FILTER_FIELDS,
  { sort: ABANDONED_CHECKOUT_SORTS },
)
  // The router keeps a param the schema leaves out, so `q` is read and thrown away instead.
  .extend({ q: z.undefined().catch(undefined) });

export type AbandonedCheckoutListSearch = z.infer<typeof abandonedCheckoutListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function abandonedCheckoutListParams(
  search: AbandonedCheckoutListSearch,
): AbandonedCheckoutListParams {
  return listParams(search, ABANDONED_CHECKOUT_FILTER_FIELDS);
}
